import log from "@/lib/log";
import {createRoot} from "react-dom/client";
import App from "@/component/App";
import "./style.scss";

const tag = "@/entry/index";

if (process.env.NODE_ENV === "development") {
    
    if (typeof localStorage.debug === "undefined") {
        log.set.all();
    }
DEBUG(tag, `

 .d8888b.  888    d8P  888             d8888 8888888b.   .d88888b.  888     888     d8888
d88P  Y88b 888   d8P   888            d88888 888  "Y88b d88P" "Y88b 888     888    d88888
Y88b.      888  d8P    888           d88P888 888    888 888     888 888     888   d88P888
 "Y888b.   888d88K     888          d88P 888 888    888 888     888 Y88b   d88P  d88P 888
    "Y88b. 8888888b    888         d88P  888 888    888 888     888  Y88b d88P  d88P  888
      "888 888  Y88b   888        d88P   888 888    888 888     888   Y88o88P  d88P   888
Y88b  d88P 888   Y88b  888       d8888888888 888  .d88P Y88b. .d88P    Y888P  d8888888888
 "Y8888P"  888    Y88b 88888888 d88P     888 8888888P"   "Y88888P"      Y8P  d88P     888

8888888888 888     888 8888888 8888888b.  8888888888 888b    888  .d8888b.  8888888888
888        888     888   888   888  "Y88b 888        8888b   888 d88P  Y88b 888
888        888     888   888   888    888 888        88888b  888 888    888 888
8888888    Y88b   d88P   888   888    888 8888888    888Y88b 888 888        8888888
888         Y88b d88P    888   888    888 888        888 Y88b888 888        888
888          Y88o88P     888   888    888 888        888  Y88888 888    888 888
888           Y888P      888   888  .d88P 888        888   Y8888 Y88b  d88P 888
8888888888     Y8P     8888888 8888888P"  8888888888 888    Y888  "Y8888P"  8888888888

Console:

    Logging:
        web.LOG("info", "gen");
        web.DEBUG("debug", "test message %O", {});
        web.log.set.all();
        web.log.set.none();
        web.log.set.filter("api/*");
    
    Store:
        web.useRouter.getState();

`);
}

const run = async () => {
    const root = createRoot(document.getElementById("root"));
    root.render(<App/>);
}

run();